<template>
     <div class="visitor-check">
        <div class="container">
            <h2 style="font-size: 44px;font-weight: 800;font-family: Gotham Pro, Courier New, Courier, monospace;">Оффлайн-проверка</h2>
            <div>Номер проверки 003</div>
        </div>
        <div class="container">
            <div class="input-container" >
            <div class="input-container request-container" >
                <div class="form-group ">
                    <div class="form-group__header">Вид проверки</div> 
                    <select class="request-select " v-model="requestType">
                        <option value="ul" selected>Юридическое лицо</option>
                        <option value="fl">Физическое лицо</option>
                    </select>
                </div>
                <div class="form-group ">
                    <div class="form-group__header">Тип проверки</div> 
                    <select class="request-select type" v-model="requestSubType" v-if="requestType == 'ul'" >
                        <option value="standart" selected>Стандарт</option>
                        <option value="extended">Расширенный</option>
                    </select>
                    <select class="request-select type" v-model="requestSubType" v-else-if="requestType == 'fl'" >
                        <option value="kadr2" selected>Кадры 2</option>
                        <option value="kadr3">Кадры 3</option>
                        <option value="kadr4">Кадры 4</option>
                    </select>
                </div>
            </div>
            <div class="input-container name-container">
                <div class="form-group company-name" v-if="requestType == 'ul'" >
                    <div class="form-group__header">Наименование</div>
                    <input class="company-name-input" v-model="name" type="text" placeholder="Наименование" >
                </div>
                <div class="form-group company-name" v-if="requestType == 'fl'" >
                    <div class="form-group__header">ФИО<span>&#42;</span></div>
                    <input class="company-name-input" v-model="name" type="text" placeholder="ФИО"  >
                </div>
                <div class="form-group inn " style="margin-right: 20px">
                    <div class="form-group__header">ИНН<span v-if="requestType === 'ul'" >&#42;</span></div> 
                    <input class="company-name-input" @input="inn = $event.target.value.replace(/[^0-9]/g, '')" placeholder="ИНН" v-model="inn" type="text"  :maxlength="12">
                </div>
            </div>
            <!-- <div class="visitor-check-block" >
                <div class="form-group form-group_inline form-group_inline-x3">
                    <div class="form-group__header">Дата рождения</div> 
                    <input @input="day = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{2})(.*)/, '$1')" v-model="day" type="text" placeholder="День" :disabled="requestType!='fl'">
                </div>
                <div class="form-group form-group_inline form-group_inline-x3">
                    <input @input="month = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{2})(.*)/, '$1')" v-model="month" type="text" placeholder="Месяц" :disabled="requestType!='fl'">
                </div>
                <div class="form-group form-group_inline form-group_inline-x3">
                    <input @input="year = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{4})(.*)/, '$1')" v-model="year" type="text" placeholder="Год" :disabled="requestType!='fl'">
                </div>
            </div> -->
            <div class="date-container" >
                <div style="font-size: 14px; margin-top: 15px; margin-bottom: 5px; font-weight: 400">Дата рождения<span v-if="requestType === 'fl'" >&#42;</span></div>
                <div class="input-container">
                    <div class="form-group" style="margin-top: 0; margin-right:0">
                        <input
                            class="date-input"
                            placeholder="День"
                            @input="day = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{2})(.*)/, '$1')"
                            v-model="day"
                            type="text"
                             :disabled="requestType!='fl'"/>
                        <input
                            class="date-input"
                            placeholder="Месяц"
                            @input="month = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{2})(.*)/, '$1')"
                            v-model="month"
                            type="text"
                            :disabled="requestType!='fl'"/>
                        <input
                            class="date-input year-input"
                            placeholder="Год"
                            @input="year = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{4})(.*)/, '$1')"
                            v-model="year"
                            type="text"
                            :disabled="requestType!='fl'"/>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="container">
            <div class="button-container" >
                <div class="form-group file-upload">
                    <div class="form-group__header">Загрузить файл</div>
                    <input id="upload-button" type="file" name="file" @change="fileChange" ref="file">
                </div>
                <div class="form-group button-holder" >
                    <button id="clear__button" class="form-group__button form-group__button_transparent" value="Поиск" @click="clearInputs" style="margin-top: 10px">Очистить</button>
                    <button id="order__button" class="form-group__button" :class="{ inactive: isDisabled }" :disabled="isDisabled" value="Поиск" @click="() => sendButtonHandler()" style="margin-top: 10px">
                        <i v-if="loading" class="lnr lnr-sync rotating" title="Загрузка" style="font-size: 18px; display: inline-block;"></i>
                        <span v-else>Поиск</span>
                    </button>
                </div>               
            </div>
        </div>
        <p class="requiered"><span>&#42;</span> - поля обязательные к заполнению</p>
        <div class="container fz16" v-if="history.list">
            <div>
                <div style="margin: 60px 0 20px;  color: rgb(30, 139, 195);font-weight: 500;font-size: 32px;">История проверок</div>
                <adminFilters :adminType="'additional_fl'" :onFilterCallback="getList" @admin-request="adminRequest" />
                <dropDownButton title="Скачать в .xlsx" :items="['Первые 5000 записей', 'Текущую страницу']" :onSelect="downloadXLSX" />
                <pagination v-if="history.pagination && history.list.length" :pagination="history.pagination" :onTurnPageCallBack="getList" :showRowsPerPageSelection="false" :rows_on_page="history.list.length" />
                <table class="content-table" style="width: 100%">
                    <tr class="content-table-body-item">
                        <th style="white-space: normal; width: 60px; padding: 0 10px 0 0;">Номер проверки</th>
                        <th>Дата проверки</th>
                        <th>Дата готовности</th>
                        <th>Вид проверки</th>
                        <th>Тип проверки</th>
                        <th>Прикр. файл</th>
                        <th>Статус</th>
                        <th>Пользователь</th>
                        <th>Объект проверки</th>
                    </tr>
                    <tr class="content-table-body-item" v-if="window.location.origin == 'https://demo.stopfactor.ru' || window.location.origin == 'https://demo.1clicom.ru'">
                        <td>0005</td>
                        <td>23.01.2020</td>
                        <td>30.01.2020</td>
                        <td>ФЛ</td>
                        <td>Кадры 4</td>
                        <td></td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                        <td class="content-table-body-item-title" style="width: auto">
                            <a href="/Булгакова_Ирина_Александровна_кадры_4.pdf" target="_blank">Булгакова Ирина Александрона, 30.05.1962</a>
                        </td>
                    </tr>
                    <tr class="content-table-body-item" v-if="window.location.origin == 'https://demo.stopfactor.ru' || window.location.origin == 'https://demo.1clicom.ru'">
                        <td>0004</td>
                        <td>22.01.2020</td>
                        <td>29.01.2020</td>
                        <td>ФЛ</td>
                        <td>Кадры 3</td>
                        <td></td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                        <td class="content-table-body-item-title" style="width: auto">
                            <a href="/Голухов_Андрей_Георгиевич_кадры_3.pdf" target="_blank">Голухов Андрей Георгиевич, 06.03.1997</a>
                        </td>
                    </tr>
                    <tr class="content-table-body-item" v-if="window.location.origin == 'https://demo.stopfactor.ru' || window.location.origin == 'https://demo.1clicom.ru'">
                        <td>0003</td>
                        <td>21.01.2020</td>
                        <td>28.01.2020</td>
                        <td>ФЛ</td>
                        <td>Кадры 2</td>
                        <td></td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                        <td class="content-table-body-item-title" style="width: auto">
                            <a href="/Дергунов_Евгений_Иванович_кадры_2.pdf" target="_blank">Дергунов Евгений Иванович, 07.10.1963</a>
                        </td>
                    </tr>
                    <tr class="content-table-body-item" v-if="window.location.origin == 'https://demo.stopfactor.ru' || window.location.origin == 'https://demo.1clicom.ru'">
                        <td>0002</td>
                        <td>20.01.2020</td>
                        <td>27.01.2020</td>
                        <td>ФЛ</td>
                        <td>Кадры 4</td>
                        <td></td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                        <td class="content-table-body-item-title" style="width: auto">
                            <a href="/Губарь Евгения Ивановна_кадры 4.pdf" target="_blank">Губарь Евгения Ивановна, 10.07.1983</a>
                        </td>
                    </tr>
                    <tr class="content-table-body-item">
                        <td>0001</td>
                        <td>19.01.2020</td>
                        <td>26.01.2020</td>
                        <td>ФЛ</td>
                        <td>эксперт</td>
                        <td></td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                        <td class="content-table-body-item-title" style="width: auto">
                            <a href="/Справка_Полная_КУЗНЕЦОВ_ИВАН_ПЕТРОВИЧ.pdf" target="_blank">Кузнецов Иван Петрович</a>
                        </td>
                    </tr>
                    <tr v-for="(e,i) in history.list" :key="i" class="content-table-body-item">
                        <td style="font-size: 14px; padding-left: 0;"><span v-if="e.number_request">{{e.number_request}}</span></td>
                        <td style="font-size: 14px;"><span v-if="e.date_request">{{e.date_request}}</span></td>
                        <td style="font-size: 14px;"><span v-if="e.date_ready">{{e.date_ready}}</span></td>
                        <td style="font-size: 14px;"><span v-if="e.vid">{{e.vid}}</span></td>
                        <td style="font-size: 14px;"><span v-if="e.type">{{e.type}}</span></td>
                        <td  style="text-align: center">
                            <a target="_blank" style="font-size: 16px" v-if="e.upl_file" :href="`https://api.1clicom.ru/download/${e.upl_file}?sid=${window.apiSession}`"><i class="lnr lnr-paperclip"></i></a>
                            <span v-else>-</span>
                        </td>
                        <td style="font-size: 14px;"><span v-if="e.status">{{e.status == 1 ? 'выполнен' : 'в работе'}}</span></td>
                        <td style="font-size: 14px;"><span v-if="admin">{{e.user}}<br>{{e.user_login ? `(${e.user_login})` : "" }}</span></td>
                        <td style="font-size: 14px;" :class="{'content-table-body-item-title': e.down_file && e.name_object}">
                            <a target="_blank" v-if="e.down_file && e.name_object" :href="`https://api.1clicom.ru/download/${e.down_file}?sid=${window.apiSession}`">
                                <span v-if="e.name_object">{{e.name_object}}</span>
                            </a>
                            <span v-else-if="e.name_object">{{e.name_object}}</span>
                            <span v-else>-</span><span v-if="e.inn">, {{e.inn}}</span><span v-if="e.bday">, {{e.bday}}</span>
                        </td>
                    </tr>
                    <!-- <tr class="content-table-body-item">
                        <td>0001</td>
                        <td>09.01.2020</td>
                        <td>14.01.2020</td>
                        <td>ФЛ</td>
                        <td>эксперт</td>
                        <td class="content-table-body-item-title" style="width: auto">
                            <a v-if="window.location.origin == 'https://demo.stopfactor.ru' || window.location.origin == 'https://demo.1clicom.ru'" href="/Справка_Полная_КУЗНЕЦОВ_ИВАН_ПЕТРОВИЧ.pdf" target="_blank">Кузнецов Иван Петрович</a>
                            <span v-else>Кузнецов Иван Петрович</span>
                        </td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                    </tr>
                    <tr class="content-table-body-item">
                        <td>0002</td>
                        <td>10.01.2020</td>
                        <td>15.01.2020</td>
                        <td>ФЛ</td>
                        <td>стандартный</td>
                        <td class="content-table-body-item-title" style="width: auto">Смиртов Алексей Юрьевич</td>
                        <td>выполнен</td>
                        <td>Петров Сергей Иванович</td>
                    </tr>
                    <tr class="content-table-body-item">
                        <td>0003</td>
                        <td>15.01.2020</td>
                        <td>20.01.2020</td>
                        <td>ЮЛ</td>
                        <td>стандартный</td>
                        <td class="content-table-body-item-title" style="width: auto"><a href="/company/1027700229193">ООО "ЯНДЕКС"</a> <tooltip style="margin-left: 5px" :ogrn="1027700229193"></tooltip></td>
                        <td>в работе</td>
                        <td>Сидоров Андрей Дмитриевич</td>
                    </tr> -->
                </table>
                <pagination v-if="history.pagination && history.list.length" :pagination="history.pagination" :onTurnPageCallBack="getList" :showRowsPerPageSelection="false" :rows_on_page="history.list.length" />
            </div>
        </div>
    </div>
</template>

<style lang="sass" scoped>
@import "styles/global-variables.sass"
.requiered
    max-width: 1280px
    width: 100%
    margin: 0 auto
    text-align: end
    padding-top: 15px
.visitor-check .form-group__button.inactive
    opacity: 0.5
    cursor: not-allowed
#group-select
    width: 370px

#user-select
    width: 542px

.table-column
    padding-left: 10px !important

.search-header
    padding-top: 15px
    font-size: 14px
    font-weight: 500

.button-row
    margin-left: 80.4%

.filter-separator
    padding-top: 3px
    font-weight: 300
    color: #b8b8b8

.date-description
    margin-left: 0 !important

.group-description
    margin-left: 220px !important

.user-description
    margin-left: 198px !important

.last-row
   margin-bottom: 30px !important

.filter-row
    display: flex
    margin: 10px 0

.date-filter__holder
    display: flex

.refresh__button
    display: inline-block
    vertical-align: top
    text-align: center
    font-weight: 500
    font-size: 14px
    color: #333
    background:transparent
    border: 0
    border-radius: 5px
    cursor: pointer
    margin-left: 20px
    width: 112px
    height: 34px
    line-height: 34px

.refresh__button:active
    color: #484747
    background-color: #a7baf9

#group-filter 
    margin-left: 15px
#user-filter
    margin-left: 15px
.filter-table
    width: 100%

.filter-header 
    padding-top: 8px
    font-size: 14px
    font-weight: 500

.filter-description
    font-size: 14px
    padding-top: 8px
    margin: 0 25px
    font-weight: 400

.type
    height: 30px !important
.lnr-cross
    cursor: pointer
    position: absolute
    right: 15px
    font-size: 26px
    bottom: 25px
.filter-input
    width: 165px
    margin-bottom: 5px
    min-height: 30px
    border-radius: 3px
    padding: 4px 8px
    border: 1px solid #b8b8b8
    box-shadow: none
    text-align: left

.fl-check .form-group 
    margin-top: 15px
    font-size: 14px
    position: relative
    margin-right: 15px

.fl-check .form-group__header 
    margin: 2px auto
    font-weight: 400
    font-size: 14px
    height: 27px

.add-select 
    width: 395px
    border: 1px solid #b8b8b8
    border-radius: 4px
    font-size: 14px

.add-select 
    option
        font-size: 14px

.monitoring__content-search-block
    width: 100%
    position: relative

.monitoring__content-search
    margin-top: 15px
    margin-bottom: 15px
    background: rgba(173, 203, 252, 0.46)
    width: 100%
    height: 46px
    line-height: 46px
    border-radius: 6px
    border: 0
    padding: 0 20px

.filters-holder
    float: right
    display: block
    margin: 20px 170px 0 0

.filters-holder button
    margin: 10px 0 0 0

.content-table-body-item-title
    font-size: 12px
    a
        font-size: 12px

.button-container
    display: flex
.button-holder
    display: flex
    gap: 5px
    text-align: right
    margin-left: 61.5%
#order__button:active
    color: #484747
    background-color: #a7baf9
#clear__button:active
    color: #484747
    background-color: #a7baf9
.date-input
    width: 70px !important
    margin-top: 0
.year-input
    width: 100px !important
input
    height: 27px
.input-container
    display: flex
.date-container
    display: flex
    flex-direction: column
.company-name
    margin-left: 165px
    margin-right: 20px
.company-name-input
    width: 200px !important
.request-select
    width: 200px !important
    border: 1px solid #b8b8b8
    border-radius: 4px
.visitor-check
    @include page
    h2
        @include page-heading
    .form-group
        @include form-group
        margin-right: 15px
    .container
        font-size: 0
    &-block
        vertical-align: top
        font-size: 0
        margin-top: 20px
        width: 50%
        display: inline-block
        &:first-child
            padding-right: 25px
        &:last-child:not(:first-child)
            padding-left: 25px
    .result
        margin: 10px auto
        p
            margin: 0
        > div
            margin: 10px auto
        table
            tr
                th
                    font-weight: 500
                td
                    font-size: 14px !important
                    font-weight: 400
                th, td
                    text-align: left
                    padding: 0 10px

a
    border: 0
    color: #07d
    text-decoration: none
    cursor: pointer
@media screen and (max-width: 1280px)
    #group-select
        width: 290px
    #user-select
        width: 475px
    .company-name
        margin-left: 100px
    .company-name-input
        width: 140px !important
    .date-input
        width: 80px !important
        margin-top: 0
    .year-input
        width: 90px !important
    .request-select
        width: 160px !important
    .button-holder
        margin-left: 51.9%
    .table-column
        padding-left: 10px !important
    .search-header
        padding-top: 15px
        font-size: 14px
        font-weight: 500

    .button-row
        margin-left: 75.2%

    .filter-separator
        padding-top: 3px
        font-weight: 300
        color: #b8b8b8

    .group-description
        margin-left: 110px !important

    .user-description
        margin-left: 115px !important

    .last-row
        margin-bottom: 30px !important

    .filter-row
        display: flex
        margin: 10px 0
    #group-filter 
        margin-left: 15px
    #user-filter
        margin-left: 15px
    .filter-table
        width: 100%

    .filter-header 
        padding-top: 8px
        font-size: 14px
        font-weight: 500

    .filter-description
        font-size: 14px
        padding-top: 8px
        margin: 0 25px
        font-weight: 400

    .type
        height: 30px !important

    .filter-input
        width: 110px

    .fl-check .form-group 
        margin-top: 15px
        font-size: 14px
        position: relative
        margin-right: 15px

    .fl-check .form-group__header 
        margin: 2px auto
        font-weight: 400
        font-size: 14px
        height: 27px

    .add-select 
        width: 335px
        border: 1px solid #b8b8b8
        border-radius: 4px
        font-size: 14px

    .add-select 
        option
            font-size: 14px

    .monitoring__content-search
        margin-top: 15px
        margin-bottom: 15px
        background: rgba(173, 203, 252, 0.46)
        width: 100%
        height: 46px
        line-height: 46px
        border-radius: 6px
        border: 0
        padding: 0 20px

    .filters-holder
        float: right
        display: block
        margin: 20px 170px 0 0

    .filters-holder button
        margin: 10px 0 0 0

    .content-table-body-item-title
        font-size: 12px
        a
            font-size: 12px

    .button-container
        display: flex
@media screen and (max-width: 1024px)
    .button-holder
        margin-left: 44%
@media screen and (max-width: 960px)
    input::placeholder
        font-size: 11px !important
    .company-name
        margin-left: 25px !important
        margin-right: 5px !important
    .company-name-input
        width: 100px !important
    .inn
        margin-right: 10px !important
    .type
        width: 130px !important
    .button-holder
        margin-left: 33.5% !important
    td
        font-size: 12px !important
        padding: 0 5px
    th 
        font-size: 12px !important
    .content
        &-table
            tr
                th, td
                    padding: 0 5px !important                   
@media screen and (max-width: 767px)
    input::placeholder
        font-size: 14px !important
    .input-container
        flex-direction: column
    .request-container
        flex-direction: row !important
    .name-container
        flex-direction: row !important
    .request-select
        width: 230px !important
    .company-name-input
        width: 230px !important
    .company-name
        margin-right: 15px !important
        margin-left: 0 !important
    .date-input
        width: 140px !important
    .year-input
        width: 185px !important
    .button-holder
        margin-left: 0 !important
    .file-upload
        margin-right: 0 !important
    button
        margin-top: 15px !important
        padding: 0 !important
        width: 110px !important
@media screen and (max-width: 480px)
    .container
        text-align: center
    .button-holder
        justify-content: center
    .request-container
        flex-direction: column !important
    .name-container
        flex-direction: column !important
    .date-input
        width: 68px !important
    .year-input
        width: 85px !important
        margin-right: 5px
    .button-container
        flex-direction: column
    #upload-button
        margin-left: 15px
    button
        padding: 0 5px !important

</style>

<script>
import axios from 'axios'
import { downloadBinaryFile } from '@/helpers'
import tooltip from '@/components/ui/tooltip'
import pagination from '@/components/ui/pagination.vue'
import adminFilters from '@/components/ui/adminFilters.vue'
import dropDownButton from '@/components/ui/dropDownButton.vue'

export default {
    components: {
        tooltip,
        adminFilters,
        dropDownButton,
        pagination
    },
    data() {
        return {
            loading: false,
            requestType: 'fl',
            requestSubType: 'kadr2',
            name: '',
            inn: '',
            year: '',
            month: '',
            day: '',
            fileId: '',
            history: {
                pagination: {},
                list: [],
                searchQuery: '',
                users: [],
                date_from: '',
                date_to: ''
            },
            checkbox: true

        }
    },
    mounted() {
        this.getList()
    },
    computed: {
        admin() {
            return this.$store.state.user.groups.filter(e => e.rules.adm_check_fl).length
        },
        isDisabled() {
            if(this.requestType === 'fl') {
                if(!this.name || !this.day || !this.month || !this.year) { return true } 
                return false
            }

            if(this.requestType === 'ul') {
                if(!this.inn) { return true }
                return false
            }
        }
    },
    watch: {
        requestType(currentValue) {
            this.name = ''
            if(currentValue == 'fl') {
                this.requestSubType = 'kadr2'
            } else if(currentValue == 'ul') {
                this.requestSubType = 'standart'
            }
        }
    },
    methods: {
        downloadXLSX(item){
            const downloadFileInsideThenFn = res => {
                downloadBinaryFile(res.data, `История запросов ${new Date().toLocaleDateString()}`, 'xlsx')
                this.downloadLoading = false
            }

            let limit, offset

            this.downloadLoading = true

            if(item == 'Первые 5000 записей') {
                limit = 5000
                offset = 0
            } else if(item == 'Текущую страницу') {
                limit = this.history.pagination.rows_per_page
                offset = limit * (this.history.pagination.current_page - 1)
            }

            this.$store.dispatch("RomAPI", {
                method: "additional_verification",
                responseType: 'arraybuffer',
                out_format: "xlsx",
                data: {
                    action: "list_user",
                    searchName: this.history.searchQuery,
                    filterUsers: this.history.users,
                    dateFrom: this.history.date_from,
                    dateTo: this.history.date_to,
                    show_adm: this.checkbox,
                    offset,
                    limit
                }
            })
                .then(downloadFileInsideThenFn)
                .finally(this.finishDownload)
        },
        adminRequest(value){
            this.checkbox = value
            console.log(this.checkbox)
        },
        fileChange(){
            const formData = new FormData()
            formData.append("userfile", this.$refs.file.files[0])
            formData.append("sid", window.apiSession)
            formData.append("method", "additional_verification")
            axios({
                method: 'post',
                url: 'https://licexpert.ru/upload/upload.php',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            }).then(e => {
                if(e.data && e.data.id_file) {
                    this.fileId = e.data.id_file
                }
            }).catch(err => {
                this.$store.dispatch("showErrorPopUp", "Ошибка загрузки файла")
                console.log("ERR", err)
            })
        },
        getList(
            offset = 0,
            limit = 50,
            searchQuery = this.history.searchQuery,
            users = this.history.users,
            date_from = this.history.date_from,
            date_to = this.history.date_to
        ) {
            this.loading = true
            this.history = {
                ...this.history,
                searchQuery,
                users,
                date_from,
                date_to
            }
            this.$store.dispatch("RomAPI", {
                method: "additional_verification",
                data: {
                    action: "list_user",
                    searchName: searchQuery,
                    filterUsers: users,
                    dateFrom: date_from,
                    dateTo: date_to,
                    show_adm: this.checkbox,
                    offset,
                    limit
                }
            }).then(e => {
                if (e.data.data && e.data.data.list && e.data.data.list.length) {
                    this.history.list = e.data.data.list
                    this.history.pagination = e.data.data.pagination
                    this.history.list.sort((a, b) => {
                        if (a.number_request * 1 < b.number_request * 1) {
                            return 1
                        } else if(a.number_request * 1 > b.number_request * 1) {
                            return -1
                        } else {
                            return 0
                        }
                    })
                }
                else if(e.data.data.list.length == 0){
                    this.history.list = []
                    this.history.pagination = {}
                }
            }).finally(() => {
                this.loading = false
            })
        },
        sendButtonHandler(){
            if(this.requestType == 'ul') {
                if(this.name) {
                    if(this.inn) {
                        this.sendInfo()
                    } else {
                        this.$store.dispatch('showErrorPopUp', 'Не введен ИНН')
                    }
                } else {
                    this.$store.dispatch('showErrorPopUp', 'Не введено наименование')
                }
            } else if(this.requestType == 'fl') {
                if(this.name) {
                    if(this.day) {
                        if(this.month) {
                            if(this.year) {
                                this.sendInfo()
                            } else {
                                this.$store.dispatch('showErrorPopUp', 'Не введен год')
                            }
                        } else {
                            this.$store.dispatch('showErrorPopUp', 'Не введен месяц')
                        }
                    } else {
                        this.$store.dispatch('showErrorPopUp', 'Не введен день')
                    }
                } else {
                    this.$store.dispatch('showErrorPopUp', 'Не введено наименование')
                }
            }
        },
        sendInfo() {
            this.loading = true
            this.$store.dispatch("RomAPI", {
                method: "additional_verification",
                data: {
                    action: "add",
                    vid: this.requestType,
                    type: this.requestSubType,
                    name: this.name,
                    inn: this.inn,
                    day: this.day,
                    month: this.month,
                    year: this.year,
                    id_file: this.fileId
                }
            }).then(e => {
                if(e && e.data && e.data.code == 0) {
                    this.$store.dispatch('showErrorPopUp', 'Заявка принята')
                    this.getList()
                }
            }).finally(() => {
                this.loading = false
            })
        },
        clearInputs() {
            this.inn = ''
            this.name = ''
            this.year = ''
            this.month = ''
            this.day = ''
            this.fileId = ''
            this.$refs.file.value = ''
        }
    }
}
</script>